"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockIsMultiLocationQuery = exports.useIsMultiLocation = void 0;
const client_1 = require("@apollo/client");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
function useIsMultiLocation(locationId) {
    var _a, _b;
    const { data, loading, error } = client_1.useQuery(MULTI_LOCATION_QUERY, {
        variables: { locationId },
        context: { locationId },
    });
    return { data: (_b = (_a = data === null || data === void 0 ? void 0 : data.location) === null || _a === void 0 ? void 0 : _a.isMultiLocation) !== null && _b !== void 0 ? _b : null, loading, error };
}
exports.useIsMultiLocation = useIsMultiLocation;
function mockIsMultiLocationQuery(locationId, isMultiLocation) {
    return {
        request: {
            query: MULTI_LOCATION_QUERY,
            variables: { locationId },
        },
        result: {
            data: {
                location: {
                    __typename: 'LocationDTO',
                    isMultiLocation,
                },
            },
        },
    };
}
exports.mockIsMultiLocationQuery = mockIsMultiLocationQuery;
const MULTI_LOCATION_QUERY = graphql_tag_1.default `
  query IsMultiLocationQuery($locationId: String!) {
    location(locationId: $locationId) {
      key
      isMultiLocation
    }
  }
`;
//# sourceMappingURL=useIsMultiLocation.js.map